import { Icon } from "./Icon";
import { Tag } from "./Tag";
import type { SkillGroup } from "../data/portfolio";

interface SkillCardProps extends SkillGroup {
  index: number;
}

/** Numbered capability group: icon tile, mono index, title, chip row. */
export function SkillCard({ title, index, skills }: SkillCardProps) {
  return (
    <article className="border-hairline bg-raised rounded-skill border p-6 shadow-sm sm:p-8">
      <div className="flex items-center gap-4">
        <span className="bg-accent-surface text-accent-strong grid size-11 place-items-center rounded-2xl">
          <Icon name="code" size={20} />
        </span>
        <div>
          <p className="text-dim font-mono text-xs">
            {String(index).padStart(2, "0")}
          </p>
          <h3 className="text-strong text-base font-semibold">{title}</h3>
        </div>
      </div>
      <div className="mt-6 flex flex-wrap gap-2">
        {skills.map((skill) => (
          <Tag key={skill} tone="solid">
            {skill}
          </Tag>
        ))}
      </div>
    </article>
  );
}
